<script setup lang="ts">
import type { ContainerProps } from "#ui/components/Container.vue";

defineProps<ContainerProps>();
</script>

<template>
  <UContainer v-bind="$props" class="[--ui-container:48.8rem]">
    <slot />
  </UContainer>
</template>
